import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringRen from "csi/heading/String";
import html from "csi/html";
import locale from "csi/locale";
import { DUMMY } from "csi/typings";
import { pathCreate } from "csi/utility/pathUtility";
import declare from "dojo/_base/declare";

export = declare(StringRen, {
	/** This is to ensure there is no issues with syncing on the Ad-hoc filter */
	restrictQuery: true,

	/** To ensure this is seen as a plain action as opposed to a string attribute action” */
	tagAction: "Action",

	/**
	 * @override
	 * Add Composition Nodes
	 */
	addRendererDependencyPaths: function (h: Heading, paths: string[]): void {
		paths.push(pathCreate(h.getClassPath(), "TechnicalComposition", "Composition;SustainabilityCompositionType"));
	},

	/**
	 * @override
	 * When displaying Composition go through the technicalComposition nodes and turn them into an organized string
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: Element): boolean {
		const compositions = [];
		ctx.getNode()?.TechnicalComposition?.forEach((technicalCompositionUrl: string) => {
			const technicalCompositionNode = ctx.cache.get(technicalCompositionUrl);
			let name = locale.getNodeName(technicalCompositionNode);
			if (technicalCompositionNode.SustainabilityCompositionType != DUMMY) {
				name = locale.getNodeName(ctx.cache.get(technicalCompositionNode.SustainabilityCompositionType)) + " " + name;
			}
			compositions.push({
				name,
				percentage: technicalCompositionNode.Percentage,
			});
		});

		// Sort compositions by percentage first and then by name
		compositions.sort((a, b) => {
			if (a.percentage !== b.percentage) {
				return b.percentage - a.percentage; // Sort by percentage in descending order
			} else {
				return a.name.localeCompare(b.name); // Sort by name in ascending order
			}
		});

		const output = compositions
			.map((comp) => `${comp.percentage}% ${comp.name}`)
			.join(", ");

		html.text(refNode, output);
		return true;
	},
});